var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.logoUrl)?_c('b-img-lazy',{staticClass:"mx-2",staticStyle:{"max-height":"2.5rem"},attrs:{"src":_vm.logoUrl}}):_c('span',[_vm._v(_vm._s(this.OverrideText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }